import React, { useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { ResetPassWrapper } from "./styled";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Col, Form, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import { PasswordResetImg } from "../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import AuthApi from "../../../services/api/authApi";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const location = useLocation();
  const navigate = useNavigate()

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const [loading, setLoading] = useState(false);

  const onSubmit = async (formData) => {
    const newFormData = {
      ...formData,
      token,
      email,
    };
    try {
      setLoading(true);
      const response = await AuthApi.resetPassword(newFormData);
      if (response.code === 200) {
        toast.success(`${t('password')} ${t('Reset_Successfully')}`);
        navigate("/login")
      } 
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
    }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ResetPassWrapper>
      <AuthHeader />
      <Box className="mt-4 container-fluid pb-4">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 px-md-5 pb-4">
              <Box className="mb-4">
                <HeadingStyled size="24px" weight="bold" color="var(--text)">
                  {t("reset_password")}
                </HeadingStyled>
                <TextStyled size="16px" color="var(--text2)">
                  {t("what_would_you_like_your_password")}
                </TextStyled>
              </Box>
              <Box>
                <Box>
                  <ValidatedInput
                    name="password"
                    label={"new_password"}
                    type="input"
                    fieldType="password"
                    placeholder={"newPasswordPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,

                      inline: true,
                      minLength: {
                        value: 8,
                        message: "lengthGreaterThen",
                      },
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <ValidatedInput
                    name="password_confirmation"
                    label={"confirm_new_password"}
                    type="input"
                    fieldType="password"
                    placeholder={"confirmNewPasswordPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: "fieldRequired",
                      },
                      inline: true,
                      validate: (value) =>
                        value === watch("password") || "password_do_not_match",
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <FormButtonStyled
                    label={t("change")}
                    color="var(--white)"
                    bg="var(--themeColor)"
                    className="w-100"
                    clName="w-100 my-4"
                    type="submit"
                    isLoading={loading}
                  />
                </Box>
              </Box>
            </Col>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5">
              <Box className="d-flex justify-content-center">
                <LazyImage src={PasswordResetImg} />
              </Box>
            </Col>
          </Row>
        </Form>
      </Box>
    </ResetPassWrapper>
  );
};

export default ResetPassword;
